import React, { createContext, useContext } from 'react';

export function createSafeContext<T>(contextName: string) {
    const Context = createContext<T | null>(null);

    const Provider = (props: React.PropsWithChildren<{ value: T }>) => (
        <Context.Provider value={props.value}>{props.children}</Context.Provider>
    );

    const useSafeContext = () => {
        const context = useContext(Context);
        if (context === null) {
            throw new Error(`use${contextName}Context must be used within a ${contextName}Provider`);
        }
        return context;
    };

    return [Provider, useSafeContext] as const;
}
